function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 12",
    style: {
      enableBackground: "new 0 0 40 12"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "white"
    },
    points: "40,6 38.4,4.5 38.4,4.5 33.59,0 31.99,1.5 35.73,5 0,5 0,7 35.73,7 31.99,10.5 33.59,12 38.4,7.5 38.4,7.5 "
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-active.b407133e.svg";
export { ForwardRef as ReactComponent };